export default __webpack_public_path__ + "static/media/273.2393d7af.jpg";